import { motion, useTransform, useViewportScroll } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';
import { device } from '../../styles/devices';
import { gutter } from '../../styles/mixins';
import { theme } from '../../styles/theme';
import { m20, p14 } from '../../styles/typography';
import useMediaQuery from '../../utils/use-media-query';

const Host = styled(motion.article)``;

const Image = styled.div<{ aspect?: number }>`
  ${(props) => props.aspect && `aspect-ratio: 1`};
  margin-bottom: ${gutter(4)};

  img {
    height: 100%;
    width: 100%;
  }

  @media ${device.tablet} {
    ${(props) => props.aspect && `aspect-ratio: ${props.aspect}`};
  }
`;

const Title = styled.h2`
  ${m20};
  margin-bottom: ${gutter(1)};
`;

const Copy = styled.p`
  ${p14};
`;

interface ImageCardProps {
  image: React.ReactNode;
  title: string;
  copy: string;
  aspect?: number;
  speed: number;
}

export const ImageCard = ({
  image,
  title,
  copy,
  aspect,
  speed,
}: ImageCardProps) => {
  const { scrollYProgress } = useViewportScroll();
  const isDesktop = useMediaQuery(
    `(min-width: ${theme.breakpoints.md.width}px)`
  );

  const yValue = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    [0, 50, 100 * speed]
  );

  return (
    <Host
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{ y: isDesktop ? yValue : 0 }}
    >
      <Image aspect={aspect}>{image}</Image>
      <Title>{title}</Title>
      <Copy>{copy}</Copy>
    </Host>
  );
};
